// Action Types
import { produce } from 'immer'

export const SET_DATA = 'advancedExports/setData'
export const SET_LOADING = 'advancedExports/setLoading'

// Action Creators
export const setData = (payload) => ({ type: SET_DATA, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })

export const initialState = {
  data: {
    columns: [],
    data: [],
    previewData: [],
  },
  loading: {
    table: false,
  },
}

export default function realtimeAdvancedExportsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    switch (action.type) {
      case SET_DATA:
        newState.data = { ...state.data, ...action.payload }
        break

      case SET_LOADING:
        newState.loading = { ...state.loading, ...action.payload }
        break

      default:
        break
    }
  })
}
